/**
 * Aviso tras el login si la puesta en marcha está incompleta (solo admin/gestor, 1 vez por sesión).
 */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const OnboardingNudge = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user || !["admin", "gestor"].includes(user.role)) return;
    if (location.pathname === "/puesta-en-marcha") return;
    if (sessionStorage.getItem("onboarding_nudge_shown")) return;
    sessionStorage.setItem("onboarding_nudge_shown", "1");
    api.get("/onboarding/estado").then(r => {
      if (r.data.completado) return;
      const pendientes = Object.values(r.data.pasos).filter(p => !p.hecho).length;
      toast.info(`Configuración inicial incompleta: ${pendientes} paso(s) pendiente(s)`, {
        description: "Completa la puesta en marcha para operar con todo (banco, series, certificado...)",
        duration: Infinity,
        closeButton: true,
        action: { label: "Configurar", onClick: () => navigate("/puesta-en-marcha") },
      });
    }).catch(() => {});
  }, [user]); // eslint-disable-line

  return null;
};
